import React from 'react';
import { HomeIcon, HeartIcon, BuildingIcon, CalendarIcon } from 'lucide-react';
export function SubscriptionPlans() {
  return <section id="plans" className="py-16 bg-pink-50" data-id="element-430">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-431">
        <div className="text-center mb-16" data-id="element-432">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-433">
            Our Subscription Plans
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-434">
            Choose the perfect plan for your home, relationships, or business
            needs
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-435">
          {/* Personal Bloom Plan */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-436">
            <div className="p-6" data-id="element-437">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-438">
                <HomeIcon className="h-6 w-6 text-pink-700" data-id="element-439" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-440">
                Personal Bloom
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-441">
                Fresh flowers and plants for your home with care tips and
                loyalty rewards.
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-442">
                <p className="text-sm text-gray-500 mb-1" data-id="element-443">Starting from</p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-444">
                  KES 2,000
                  <span className="text-sm font-normal text-gray-500" data-id="element-445">
                    /month
                  </span>
                </p>
              </div>
              <button className="mt-6 w-full px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-446">
                Choose This Plan
              </button>
            </div>
          </div>
          {/* Relationship Saver Plan */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-447">
            <div className="p-6" data-id="element-448">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-449">
                <HeartIcon className="h-6 w-6 text-pink-700" data-id="element-450" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-451">
                Relationship Saver
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-452">
                Automated reminders, personalized notes, and emergency delivery
                options.
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-453">
                <p className="text-sm text-gray-500 mb-1" data-id="element-454">Starting from</p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-455">
                  KES 4,500
                  <span className="text-sm font-normal text-gray-500" data-id="element-456">
                    /quarter
                  </span>
                </p>
              </div>
              <button className="mt-6 w-full px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-457">
                Choose This Plan
              </button>
            </div>
          </div>
          {/* Corporate Bloom Plan */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-458">
            <div className="p-6" data-id="element-459">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-460">
                <BuildingIcon className="h-6 w-6 text-pink-700" data-id="element-461" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-462">
                Corporate Bloom
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-463">
                Bulk orders, branded cards, and dedicated dashboards for your
                business.
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-464">
                <p className="text-sm text-gray-500 mb-1" data-id="element-465">Starting from</p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-466">
                  KES 10,000
                  <span className="text-sm font-normal text-gray-500" data-id="element-467">
                    /month
                  </span>
                </p>
              </div>
              <button className="mt-6 w-full px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-468">
                Choose This Plan
              </button>
            </div>
          </div>
          {/* Event Packs Plan */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-469">
            <div className="p-6" data-id="element-470">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-471">
                <CalendarIcon className="h-6 w-6 text-pink-700" data-id="element-472" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-473">
                Event Packs
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-474">
                Priority delivery and design support for your special events.
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-475">
                <p className="text-sm text-gray-500 mb-1" data-id="element-476">Starting from</p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-477">
                  KES 15,000
                  <span className="text-sm font-normal text-gray-500" data-id="element-478">
                    /event
                  </span>
                </p>
              </div>
              <button className="mt-6 w-full px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-479">
                Choose This Plan
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}